// src/contexts/AdminAuthContext.js
import React, { createContext, useState, useEffect, useContext } from 'react';
import AuthService from './auth';

const AdminAuthContext = createContext();

export function AdminAuthProvider({ children }) {
  const [currentAdmin, setCurrentAdmin] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function loadAdmin() {
      const admin = await AuthService.getCurrentAdmin(); // Changed from AdminAuthContext to AuthService
      setCurrentAdmin(admin);
      setLoading(false);
    }
    loadAdmin();
  }, []);

  const login = async (email, password) => {
    try {
      const response = await AuthService.login(email, password); // Changed to AuthService
      setCurrentAdmin(response.admin || response); // Handle both response formats
      return response;
    } catch (error) {
      throw error;
    }
  };

  const logout = async () => {
    await AuthService.logout(); // Changed to AuthService
    setCurrentAdmin(null);
  };

  const value = {
    currentAdmin,
    login,
    logout,
    loading
  };

  return (
    <AdminAuthContext.Provider value={value}>
      {!loading && children}
    </AdminAuthContext.Provider>
  );
}

export function useAuth() {
  const context = useContext(AdminAuthContext);
  if (context === undefined) {
    throw new Error('useAuth must be used within an AdminAuthProvider');
  }
  return context;
}